(function ($) {

    /**
     * Init Nice Select
     */
    $('.c-quick-search-sentance select').niceSelect();

    /**
     * S24 - Quick search
     */
    function buildQuickSearchUrl() {
        var roomsSelected = $('#qs-rooms').val();
        var featureSelected = $('#qs-features').val();
        var featureType = $('#qs-features').find(':selected').data('feature-type');
        var baseURL = $('.js-quick-search-link').data('base-url');
        var finalURL = baseURL;

        if ( featureType == 'apartment-layout-feature' ) {
            var dataForUrlParams = {
                'room-count': roomsSelected,
                'apartment-layout-feature': featureSelected,
            };
        } else {
            var dataForUrlParams = {
                'room-count': roomsSelected,
                'apartment-feature': featureSelected,
            };
        }

        var urlParams = new URLSearchParams(dataForUrlParams);
        var finalURL = baseURL+'?'+urlParams.toString();

        $('.js-quick-search-link').attr('href', finalURL);
    }

    buildQuickSearchUrl();

    $( document ).on('change', '#qs-rooms, #qs-features', function() {
        buildQuickSearchUrl();
    });

})(jQuery);
